import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const MeldingenApi = {
    saveMelding(model, documents) {
        const serviceUrl = prependRoot('/meldingen', getApiRoot());
        return axios.put(serviceUrl,
            {
                item: model,
                documenten: documents
            },
            {
                headers: {
                    'accept': 'application/json'
                }
            });
    }
};

export default MeldingenApi;
